import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link as RouterLink, useLocation } from 'react-router-dom';
import './index.css';

import Home from './pages/Home';
import SoftwareEngineer from './pages/SoftwareEngineer';
import Innovation from './pages/Innovation';
import Journalism from './pages/Journalism';
import PrivatePilot from './pages/PrivatePilot';
import ResearchStreamTechnologies from './pages/ResearchStreamTechnologies';
import Contact from './pages/Contact';
import FrontendDeveloper from './pages/FrontendDeveloper';
import GameDeveloper from './pages/GameDeveloper';
import LostAndFound from './pages/LostAndFound';
import ScrollToTop from './components/ScrollToTop';

const navLinks = [
  { text: '~/home', path: '/' },
  { text: '~/software-eng', path: '/software-engineer' },
  { text: '~/innovation', path: '/innovation' },
  { text: '~/journalism', path: '/journalism' },
  { text: '~/aviation', path: '/private-pilot' },
  { text: '~/research', path: '/research-stream-technologies' },
  { text: '$ contact', path: '/contact' },
];

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => setMobileOpen(!mobileOpen);

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <RouterLink to="/" className="nav-brand">
          ariel_rotem<span className="cursor"></span>
        </RouterLink>
        <button className="mobile-toggle" onClick={toggleMenu}>
          {mobileOpen ? 'x' : '≡'}
        </button>
        <div className={`nav-links ${mobileOpen ? 'open' : ''}`}>
          {navLinks.map((link) => (
            <RouterLink 
              key={link.path} 
              to={link.path} 
              className={`nav-link ${location.pathname === link.path ? 'active' : ''}`}
              onClick={() => setMobileOpen(false)}
            >
              {link.text}
            </RouterLink>
          ))}
        </div>
      </div>
    </nav>
  );
};

const Footer = () => (
  <footer className="footer">
    <div>arielrotem@gmail.com | Hoboken, NJ</div>
    <div className="mt-1">© {new Date().getFullYear()} System initialized. All rights reserved.</div>
    <div className="mt-2" style={{ opacity: 0.5, fontSize: '0.7rem' }}>
      Associated Research: <a href="https://eurekabytelabs.com/" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>Eureka Byte Labs</a>
    </div>
  </footer>
);

const AppContent = () => (
  <>
    <ScrollToTop />
    <Navbar />
    <main className="main-content container">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/software-engineer" element={<SoftwareEngineer />} />
        <Route path="/innovation" element={<Innovation />} />
        <Route path="/journalism" element={<Journalism />} />
        <Route path="/private-pilot" element={<PrivatePilot />} />
        <Route path="/research-stream-technologies" element={<ResearchStreamTechnologies />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/frontend-developer" element={<FrontendDeveloper />} />
        <Route path="/game-developer" element={<GameDeveloper />} />
        <Route path="/lost-and-found" element={<LostAndFound />} />
      </Routes>
    </main>
    <Footer />
  </>
);

const FullPageWrapper = () => {
  const location = useLocation();
  const isMordor = location.pathname === '/lost-and-found';
  const [wipeComplete, setWipeComplete] = useState(!isMordor);

  useEffect(() => {
    if (isMordor) {
      setWipeComplete(false);
      const timer = setTimeout(() => {
        document.documentElement.classList.add('mordor-theme');
        setWipeComplete(true);
      }, 4200);
      return () => {
        clearTimeout(timer);
        document.documentElement.classList.remove('mordor-theme');
      };
    } else {
      document.documentElement.classList.remove('mordor-theme');
      setWipeComplete(true);
    }
  }, [isMordor]);

  if (!isMordor) {
    return <AppContent />;
  }

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      
      {/* Base Layer: Standard Green Theme (maintains layout flow permanently) */}
      <div className={!wipeComplete ? 'dying-system' : ''} style={{ width: '100%' }}>
        <AppContent />
      </div>

      {/* Top Layer: Mordor Red Theme (wipes down) */}
      <div 
        className="mordor-wipe-red mordor-theme" 
        style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, pointerEvents: wipeComplete ? 'auto' : 'none' }}
      >
        <AppContent />
      </div>

      {/* Laser line scanning down */}
      <div className="mordor-laser" />
    </div>
  );
};

function App() {
  return (
    <Router>
      <FullPageWrapper />
    </Router>
  );
}

export default App;
